var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "clock",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#00558D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5V12H18",
    stroke: "#00558D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    id: "mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLnejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.244 7.47h-25.572v17.060h26.656v-17.060h-1.084zM27.177 8.536l-10.298 10.298c-0.47 0.47-1.289 0.47-1.759 0l-10.3-10.298h22.356zM3.738 8.961l6.923 6.922-6.923 6.923v-13.846zM4.589 23.464l6.827-6.826 2.951 2.95c0.436 0.436 1.016 0.677 1.633 0.677s1.197-0.241 1.633-0.677l2.951-2.951 6.826 6.826h-22.822zM28.262 22.807l-6.923-6.924 6.923-6.924v13.848z"
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01394 6.87134C1.34749 10.0618 3.85967 13.8597 7.01471 17.0147C10.1698 20.1698 13.9676 22.682 17.1581 22.0155C19.782 21.4674 21.1215 20.0697 21.8754 18.8788C22.1355 18.4678 22.0042 17.9344 21.6143 17.6436L17.9224 14.8897C17.5243 14.5928 16.9685 14.633 16.6174 14.9842L14.6577 16.9438C14.6577 16.9438 12.7529 16.3246 10.2288 13.8006C7.70482 11.2766 7.08564 9.37175 7.08564 9.37175L9.04529 7.4121C9.39648 7.06091 9.43671 6.5052 9.13975 6.10709L6.38585 2.4151C6.09505 2.02525 5.56163 1.89395 5.15068 2.15407C3.9597 2.90794 2.56203 4.24747 2.01394 6.87134Z",
    stroke: "#00558D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "pin",
    viewBox: "0 0 32 32",
    version: 1.1,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.961 1.25c-6.167 0.346-11.114 5.134-11.707 11.199l-0.004 0.051c0 4.65 9.998 16.633 11.138 17.984 0.138 0.163 0.343 0.265 0.572 0.266h0.001c0 0 0.001 0 0.001 0 0.228 0 0.432-0.102 0.569-0.263l0.001-0.001c1.148-1.352 11.218-13.334 11.218-17.986-0.62-6.132-5.597-10.924-11.758-11.249l-0.031-0.001zM15.963 28.832c-3.31-4.014-10.213-13.060-10.213-16.332 0.601-5.283 4.875-9.398 10.178-9.748l0.033-0.002c5.361 0.332 9.666 4.451 10.284 9.698l0.005 0.052c0 3.271-6.955 12.32-10.287 16.332zM19.232 8.521l-5.151 5.627-1.338-1.328c-0.135-0.13-0.318-0.21-0.521-0.21-0.414 0-0.75 0.336-0.75 0.75 0 0.204 0.082 0.389 0.214 0.525l-0-0 1.892 1.879 0.015 0.006 0.007 0.015c0.13 0.122 0.306 0.196 0.499 0.196 0.201 0 0.383-0.081 0.515-0.212l-0 0 0.024-0.010 0.004-0.010 0.017-0.012 5.677-6.204c0.123-0.133 0.198-0.311 0.198-0.507 0-0.414-0.335-0.749-0.749-0.749-0.219 0-0.417 0.094-0.554 0.244l-0.001 0.001z"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 6.5,
    stroke: "#000000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6464 20.3536C19.8417 20.5488 20.1583 20.5488 20.3536 20.3536C20.5488 20.1583 20.5488 19.8417 20.3536 19.6464L19.6464 20.3536ZM20.3536 19.6464L15.3536 14.6464L14.6464 15.3536L19.6464 20.3536L20.3536 19.6464Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    fill: "none",
    viewBox: "-6.4 -6.4 76.80 76.80",
    id: "account"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18.14,
    r: 11.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.55,56.85A22.55,22.55,0,0,0,32,34.3h0A22.55,22.55,0,0,0,9.45,56.85Z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "cart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9H6.84713C6.35829 9 5.9411 9.35341 5.86073 9.8356L4.19407 19.8356C4.09248 20.4451 4.56252 21 5.18046 21H18.8195C19.4375 21 19.9075 20.4451 19.8059 19.8356L18.1393 9.8356C18.0589 9.35341 17.6417 9 17.1529 9H15M9 9H15M9 9C8.66667 7.66667 8 3 12 3C16 3 15.3333 7.66667 15 9"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "catalog"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9.75h5c0.966-0.001 1.749-0.784 1.75-1.75v-5c-0.001-0.966-0.784-1.749-1.75-1.75h-5c-0.966 0.001-1.749 0.784-1.75 1.75v5c0.001 0.966 0.784 1.749 1.75 1.75h0zM2.75 3c0-0.138 0.112-0.25 0.25-0.25h5c0.138 0 0.25 0.112 0.25 0.25v5c-0 0.138-0.112 0.25-0.25 0.25h-5c-0.138-0-0.25-0.112-0.25-0.25v-0zM13.5 9.75h5c0.966-0.001 1.749-0.784 1.75-1.75v-5c-0.001-0.966-0.784-1.749-1.75-1.75h-5c-0.966 0.001-1.749 0.784-1.75 1.75v5c0.001 0.966 0.784 1.749 1.75 1.75h0zM13.25 3c0-0.138 0.112-0.25 0.25-0.25h5c0 0 0 0 0 0 0.138 0 0.25 0.112 0.25 0.25 0 0 0 0 0 0v0 5c0 0 0 0 0 0 0 0.138-0.112 0.25-0.25 0.25-0 0-0 0-0 0h-5c-0.138-0-0.25-0.112-0.25-0.25v-0zM24 9.723h4.973c0.966-0.001 1.749-0.784 1.75-1.75v-4.973c-0.001-0.966-0.784-1.749-1.75-1.75h-4.973c-0.966 0.001-1.749 0.784-1.75 1.75v4.973c0.001 0.966 0.784 1.749 1.75 1.75h0zM23.75 3c0-0 0-0 0-0 0-0.138 0.112-0.25 0.25-0.25 0 0 0 0 0 0h4.973c0 0 0 0 0 0 0.138 0 0.25 0.112 0.25 0.25 0 0 0 0 0 0v0 4.973c0 0 0 0 0 0 0 0.138-0.112 0.25-0.25 0.25-0 0-0 0-0 0h-4.973c-0 0-0 0-0 0-0.138 0-0.25-0.112-0.25-0.25 0-0 0-0 0-0v0zM3.014 20.25h5c0.966-0.001 1.749-0.784 1.75-1.75v-5c-0.001-0.966-0.784-1.749-1.75-1.75h-5c-0.966 0.001-1.749 0.784-1.75 1.75v5c0.001 0.966 0.784 1.749 1.75 1.75h0zM2.764 13.5c0-0.138 0.112-0.25 0.25-0.25h5c0.138 0 0.25 0.112 0.25 0.25v5c0 0 0 0 0 0 0 0.138-0.112 0.25-0.25 0.25-0 0-0 0-0 0h-5c-0 0-0 0-0 0-0.138 0-0.25-0.112-0.25-0.25 0-0 0-0 0-0v0zM13.514 20.25h5c0.966-0.001 1.749-0.784 1.75-1.75v-5c-0.001-0.966-0.784-1.749-1.75-1.75h-5c-0.966 0.001-1.749 0.784-1.75 1.75v5c0.001 0.966 0.784 1.749 1.75 1.75h0zM13.264 13.5c0-0.138 0.112-0.25 0.25-0.25h5c0 0 0 0 0 0 0.138 0 0.25 0.112 0.25 0.25 0 0 0 0 0 0v0 5c0 0 0 0 0 0.001 0 0.138-0.112 0.249-0.249 0.249-0 0-0.001 0-0.001 0h-5c-0 0-0 0-0 0-0.138 0-0.25-0.112-0.25-0.25 0-0 0-0 0-0v0zM24.014 20.223h4.973c0.966-0.001 1.749-0.784 1.75-1.75v-4.973c-0.001-0.966-0.784-1.749-1.75-1.75h-4.973c-0.966 0.001-1.749 0.784-1.75 1.75v4.973c0.001 0.966 0.784 1.749 1.75 1.75h0zM23.764 13.5c0-0 0-0 0-0 0-0.138 0.112-0.25 0.25-0.25 0 0 0 0 0 0h4.973c0 0 0 0 0 0 0.138 0 0.25 0.112 0.25 0.25 0 0 0 0 0 0v0 4.973c0 0 0 0 0 0.001 0 0.138-0.112 0.249-0.249 0.249-0 0-0.001 0-0.001 0h-4.973c-0 0-0 0-0.001 0-0.138 0-0.249-0.112-0.249-0.249 0-0 0-0.001 0-0.001v0zM8.027 22.25h-5c-0.966 0.001-1.749 0.784-1.75 1.75v5c0.001 0.966 0.784 1.749 1.75 1.75h5c0.966-0.001 1.749-0.784 1.75-1.75v-5c-0.001-0.966-0.784-1.749-1.75-1.75h-0zM8.277 29c0 0 0 0 0 0 0 0.138-0.112 0.25-0.25 0.25-0 0-0 0-0 0h-5c-0 0-0 0-0 0-0.138 0-0.25-0.112-0.25-0.25 0-0 0-0 0-0v0-5c0-0 0-0 0-0 0-0.138 0.112-0.25 0.25-0.25 0 0 0 0 0 0h5c0 0 0 0 0 0 0.138 0 0.25 0.112 0.25 0.25 0 0 0 0 0 0v0zM18.527 22.25h-5c-0.966 0.001-1.749 0.784-1.75 1.75v5c0.001 0.966 0.784 1.749 1.75 1.75h5c0.966-0.001 1.749-0.784 1.75-1.75v-5c-0.001-0.966-0.784-1.749-1.75-1.75h-0zM18.777 29c0 0 0 0 0 0.001 0 0.138-0.112 0.249-0.249 0.249-0 0-0.001 0-0.001 0h-5c-0 0-0 0-0 0-0.138 0-0.25-0.112-0.25-0.25 0-0 0-0 0-0v0-5c0-0 0-0 0-0 0-0.138 0.112-0.25 0.25-0.25 0 0 0 0 0 0h5c0 0 0 0 0.001 0 0.138 0 0.249 0.112 0.249 0.249 0 0 0 0.001 0 0.001v-0zM29 22.25h-4.973c-0.966 0.001-1.749 0.784-1.75 1.75v4.973c0.001 0.966 0.784 1.749 1.75 1.75h4.973c0.966-0.001 1.749-0.784 1.75-1.75v-4.973c-0.001-0.966-0.784-1.749-1.75-1.75h-0zM29.25 28.973c0 0 0 0 0 0.001 0 0.138-0.112 0.249-0.249 0.249-0 0-0.001 0-0.001 0h-4.973c-0 0-0 0-0.001 0-0.138 0-0.249-0.112-0.249-0.249 0-0 0-0.001 0-0.001v0-4.973c0-0 0-0 0-0.001 0-0.138 0.112-0.249 0.249-0.249 0 0 0.001 0 0.001 0h4.973c0 0 0 0 0.001 0 0.138 0 0.249 0.112 0.249 0.249 0 0 0 0.001 0 0.001v-0z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    id: "telegram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 300 300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_496_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    d: "M5.299,144.645l69.126,25.8l26.756,86.047c1.712,5.511,8.451,7.548,12.924,3.891l38.532-31.412 c4.039-3.291,9.792-3.455,14.013-0.391l69.498,50.457c4.785,3.478,11.564,0.856,12.764-4.926L299.823,29.22 c1.31-6.316-4.896-11.585-10.91-9.259L5.218,129.402C-1.783,132.102-1.722,142.014,5.299,144.645z M96.869,156.711l135.098-83.207 c2.428-1.491,4.926,1.792,2.841,3.726L123.313,180.87c-3.919,3.648-6.447,8.53-7.163,13.829l-3.798,28.146 c-0.503,3.758-5.782,4.131-6.819,0.494l-14.607-51.325C89.253,166.16,91.691,159.907,96.869,156.711z"
  }))))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "whatsapp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
  })))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    id: "pneumo",
    sodipodiDocname: "pshm180u-2.jpg",
    inkscapeExportFilename: "..\\\\\\\\..\\\\\\\\..\\\\\\\\pneumo.svg",
    inkscapeExportXdpi: 8,
    inkscapeExportYdpi: 8,
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2400 2400"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }), /*#__PURE__*/React.createElement("g", {
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Image",
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1177.8928,1275.8678 c 12.278,-268.5266 110.1154,-472.45793 403.4105,-581.72956",
    id: "path1",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1202.8319,1269.0164 c 15.1156,-251.3781 112.8132,-458.289 378.0546,-574.98398",
    id: "path2",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1143.7947,1285.776 542.0865,-148.3116 c 11.7163,-2.5407 15.3248,-9.2751 12.9191,-19.1203 -3.9417,-12.3451 -2.3964,-21.7115 -1.3989,-28.4588 -19.9389,-13.8693 -24.136,-27.5874 -18.4208,-50.5436 -62.7218,-186.5444 -111.8288,-375.41326 -134.693,-568.76257 -0.7859,-7.98904 -1.7346,-16.7097 -4.2808,-21.50107 -4.4609,-8.3947 -11.82,-10.34279 -17.433,-15.38515 -9.1757,-8.24289 -10.2685,-22.80081 9.2469,-30.35782 46.6564,-17.96377 86.2198,-26.95734 145.5434,-36.63871 15.4092,-1.21478 20.1524,3.80155 22.2967,8.48596 4.5441,9.9272 -1.2388,21.92628 -7.3582,31.09163 -3.7585,5.62951 -0.072,13.47931 3.1388,24.77264 56.1977,179.95194 101.6996,365.50475 124.1023,554.51744 5.0834,40.25455 28.745,30.00735 13.7447,71.67265 l 20.7353,71.1843 c 3.8371,16.3787 6.4194,32.2725 -4.6509,42.8915 l -12.144,8.5266 c -11.3324,11.196 -21.5763,-2.1002 -32.2978,-4.6509 -29.5702,-16.6524 -36.3719,-49.4689 -106.712,-45.4753",
    id: "path3",
    sodipodiNodetypes: "ccccccssccsscccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1531.3421,439.94574 c 3.3217,1.08515 7.6531,1.45035 10.1351,1.18764 58.0588,-6.14518 104.3052,-22.66393 149.5989,-39.65184 2.1578,-0.8093 6.0044,-3.94532 6.9674,-5.26194",
    id: "path21",
    sodipodiNodetypes: "cssc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1678.9695,1039.279 c 66.3578,-1.446 114.47,-12.0148 147.7053,-30.022",
    id: "path22",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1697.503,1090.0122 c 65.2156,-2.8972 106.3623,-15.5145 135.8501,-32.8402",
    id: "path23",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1762.0501,669.78281 c 284.3102,44.02616 425.6633,218.01327 496.1716,456.40479 l -227.7406,51.7966 c -36.1694,-62.0095 -88.9322,-105.3073 -189.5097,-94.6864",
    id: "path24",
    sodipodiNodetypes: "cccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2030.4989,1177.9012 c 17.9589,53.4145 29.7183,109.2713 -15.639,187.6286 -10.7655,16.5108 -16.0742,12.6908 -10.9622,31.0597 l 10.5968,40.1949 c 1.4328,12.9111 3.873,25.8222 -8.039,38.7333 -67.2761,58.3072 -150.7294,89.5422 -251.7661,91.352 -23.2517,-1.0942 -47.0612,-1.4831 -47.503,-31.4251 0.2562,-16.4697 -7.5149,-22.3435 -24.4824,-16.078 -171.3813,46.238 -330.4666,99.183 -495.1279,149.0865 10.5301,-19.3737 11.3602,-42.7721 10.4404,-61.126 -4.6142,-92.0771 -24.9389,-190.0451 -74.8303,-265.955 -10.1893,-15.5031 -28.7106,-37.7867 -43.4054,-37.9616 l 64.3699,-17.7393",
    id: "path25",
    sodipodiNodetypes: "cccccccccsscc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1219.5654,1308.9658 350.8835,-97.6686 c 35.9972,-5.5747 47.1966,19.5292 17.57,36.6903 l -353.9841,98.7021 c -38.9842,2.434 -40.728,-30.4228 -14.4694,-37.7238 z",
    id: "path26",
    sodipodiNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1677.4192,1520.9686 117.4651,-39.6044 c 36.552,-16.5116 45.1461,-47.7778 52.8366,-78.7546 11.785,-31.212 39.8349,-43.7936 51.9441,-43.9312 23.9941,-1.7185 46.4246,-2.0083 59.2875,-0.091 13.4942,1.8661 31.7171,12.7036 46.8636,18.3617",
    id: "path27",
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1188.0427,1668.1174 -118.3391,-13.4359 c -10.2067,-1.9871 -13.5423,-5.38 -23.7712,-1.5502 l -32.5562,11.8855 c -6.6695,2.0461 -20.88807,3.7029 -31.00593,-4.6508 l -6.71794,-7.7515 -8.785,2.713 c -1.09895,7.7251 -3.52998,15.0379 -14.72781,19.6371 l -21.56084,6.6985 c -4.33503,6.1549 -5.65545,7.0475 -10.99535,9.4504 l -268.20104,80.8737 c -11.58231,-6.9396 -17.57137,-16.3154 -24.67553,-30.4892 l -94.4388,23.2545 c 3.78043,-57.715 -5.2268,-118.0273 -31.52267,-158.3885 l -20.15383,-25.0631 73.89739,-20.4122 c 2.17152,-3.834 7.00231,-6.9286 10.07692,-7.4931 l 11.11045,-1.8087 c -2.05305,-25.4553 -2.6636,-41.1629 6.45956,-48.8343 l 266.90912,-72.3471 c 7.67769,-2.088 13.59578,-1.1847 17.8284,2.5839 l 24.02957,-6.4596 c 5.23118,-2.0219 10.09115,0.058 12.91912,2.8422 l 3.87574,3.8757 6.71795,-1.5503 c 2.07166,-17.3812 7.21623,-23.8433 13.69427,-26.6134 l 48.26033,-12.1486 c 6.36408,-2.7052 12.20904,-6.3622 17.53959,-10.9622 l 85.74143,-78.4981",
    id: "path28",
    sodipodiNodetypes: "ccccccccccccccccccccccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 498.78197,1603.9586 75.09136,-21.3764 -19.54933,-21.5591 c 17.89909,-7.4959 21.5178,5.3107 19.38689,21.4024",
    id: "path29",
    sodipodiNodetypes: "cccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 575.60901,1551.5225 c 3.15294,0.8712 7.33851,4.2703 8.88233,7.2809 29.31907,57.1749 42.93375,110.1756 42.22912,182.777",
    id: "path30",
    sodipodiNodetypes: "csc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 582.33416,1502.8061 c 3.51042,0.076 6.94116,3.595 9.09435,6.8606 41.49806,62.937 54.05681,135.8316 59.24903,209.3836 1.25011,17.7088 1.83539,35.729 0.70797,52.9046",
    id: "path31",
    sodipodiNodetypes: "cssc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 977.84858,1392.2941 c 10.21625,2.6549 23.49702,21.522 32.38882,36.8838 39.8234,68.8009 52.0831,167.3265 43.7821,221.7356",
    id: "path32",
    sodipodiNodetypes: "csc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 995.0767,1665.9891 c 9.7561,-6.6441 9.1195,-27.2991 9.1206,-41.8085 0,-31.5532 -3.1074,-62.6588 -10.08041,-93.2915 -5.38064,-23.6372 -12.7726,-46.2077 -22.69568,-70.4209 -5.50771,-13.4393 -10.88283,-26.2932 -19.61219,-38.3368 -6.90306,-9.5239 -14.58409,-14.6876 -23.53557,-17.0004",
    id: "path33",
    sodipodiNodetypes: "cssssc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 973.62972,1653.2887 c 10.00525,-3.5605 19.10244,-5.827 21.19367,-29.598 -0.96146,-43.6214 -9.83698,-77.0915 -20.82826,-117.6614 -6.78663,-22.5083 -11.83128,-43.1436 -30.63696,-66.3197 -6.77119,-6.9196 -9.66607,-8.9386 -12.75524,-10.8728 -2.48346,-0.8941 -8.87461,-1.5362 -16.18725,2.7961",
    id: "path34",
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 907.43184,1433.0722 c 31.71153,43.8498 44.5015,84.5272 53.77856,123.9627 8.42535,35.815 8.81225,66.2934 5.64078,98.3088",
    id: "path35",
    sodipodiNodetypes: "csc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 866.74787,1432.9476 c 40.41632,52.9294 67.20396,127.1536 63.67235,248.7516",
    id: "path36",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 532.21681,1764.7381 -13.97686,-20.8282 -9.4848,-1.2491 c 2.04074,-51.3248 -8.80176,-94.6157 -34.10649,-129.8372 l 4.26331,-1.0335 c -1.03172,-12.3091 -1.80198,-28.4975 1.67232,-30.4435",
    id: "path37",
    sodipodiNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 508.75515,1742.5316 c -2.68134,4.3552 -7.0608,7.7401 -12.14398,10.7229 l -32.03943,9.4309 c -5.92763,-3.0274 -11.20001,-8.2077 -14.7278,-19.1203 2.15543,-40.0828 -8.68591,-70.5384 -25.06311,-96.8934 -4.07977,-21.7426 4.65657,-29.4574 12.14398,-32.0394 l 28.68046,-8.5267 c 3.55415,0.085 7.07284,3.9515 9.04339,6.718",
    id: "path38",
    sodipodiNodetypes: "cccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 483.75735,1626.9255 c 1.69101,3.0719 3.26165,14.4697 2.87481,28.5556 13.68358,19.3548 24.27518,40.932 16.18019,75.9401 1.67313,4.6406 3.08886,9.1954 3.73455,13.4935",
    id: "path39",
    sodipodiNodetypes: "cccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 430.85282,1618.1204 c -1.65687,22.6162 9.66588,34.8488 19.76627,48.0592 -1.75231,26.2728 0.69325,51.4662 15.89052,73.3806 -2.5325,6.8127 -4.39696,13.686 -5.03846,20.6706",
    id: "path40",
    sodipodiNodetypes: "cccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 450.73082,1666.2607 35.99269,-10.8709",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 466.62607,1739.4336 35.99269,-8.039",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 449.71475,1743.4359 c -1.93649,-1.3388 -4.26469,-1.5895 -6.97633,-0.7751 l -92.37175,28.2929 c -19.13644,5.9713 -23.10844,3.0341 -29.4556,4.6509 -8.70171,0.9338 -6.21958,8.4036 -23.25443,13.4358 -12.8921,2.0213 -24.53629,2.008 -25.32148,2.0671 -8.5021,-0.036 -11.22702,9.8263 -21.18737,12.4024 l -43.92502,3.6173 c -2.59134,-26.1603 -7.90031,-53.097 -20.6706,-82.1656 l 33.07296,-16.0197 c 10.93547,-6.8403 16.40374,-1.4672 20.6706,-3.1006 13.9784,-1.6636 19.13039,-10.5247 29.97237,-12.9191 12.90038,-3.2876 15.18267,-0.7275 20.6706,-2.0671 8.55449,-1.805 14.42856,-5.1418 20.6706,-8.2682 7.40696,-4.4348 14.90528,-6.0111 22.22089,-8.2683 l 90.88814,-27.1962",
    id: "path43",
    sodipodiNodetypes: "cccccccccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 320.46285,1678.5018 c 17.10453,27.7974 25.70616,59.0491 27.2229,93.1791",
    id: "path44",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 289.51759,1691.2427 c 14.97047,26.7377 25.11411,55.2855 24.54634,87.85",
    id: "path45",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 239.91322,1706.2729 c 20.92107,32.4818 22.36937,61.8106 21.2142,90.933",
    id: "path46",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 186.5408,1725 c 2.93899,31.5659 10.459,61.2285 20.62434,82.0881",
    id: "path47",
    sodipodiNodetypes: "cc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.56e8fe407a0ac2abb19050a47e835ddd.svg";
export { ForwardRef as ReactComponent };